export type ClipboardCopyMethod = 'clipboard' | 'execCommand' | 'none';

export interface ClipboardCopyResult {
  success: boolean;
  method: ClipboardCopyMethod;
  error?: unknown;
}

function fallbackCopyByExecCommand(text: string): boolean {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', 'true');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    const copied = document.execCommand('copy');
    document.body.removeChild(textarea);
    return copied;
  } catch {
    return false;
  }
}

export async function copyTextWithFallback(
  text: string,
): Promise<ClipboardCopyResult> {
  let clipboardError: unknown;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return { success: true, method: 'clipboard' };
    }
  } catch (error) {
    clipboardError = error;
  }

  const copiedByExecCommand = fallbackCopyByExecCommand(text);
  if (copiedByExecCommand) {
    return { success: true, method: 'execCommand', error: clipboardError };
  }

  return { success: false, method: 'none', error: clipboardError };
}
